var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStratDiversify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 62.6666V60C61.6826 58.9623 61.4486 57.936 60.9845 57.0077C60.5203 56.0795 59.8397 55.2765 59 54.6666C55.44 51.9493 47.6134 46.6666 32.3334 46.6666C17.0534 46.6666 9.22669 51.9493 5.66669 54.6666C4.82701 55.2765 4.14638 56.0795 3.68225 57.0077C3.21813 57.936 2.98414 58.9623 3.00003 60V62.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 62.6666L46.5253 48.4746",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3334 62.6666L18.1414 48.4746",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 58.6666L32.3333 46.6666L28.3333 58.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4426 49.3359L12.3333 58.6666L20.3333 62.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2239 49.3359L52.3333 58.6666L44.3333 62.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 41.3334H27",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 1.33337V4.00004",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 20H51",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 6.66663L48.3333 9.33329",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H13.6667",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 6.66663L16.3332 9.33329",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 33.3333L48.3333 30.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 33.3333L16.3332 30.6666",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3331 21.3333C44.3422 19.1927 43.7785 17.0885 42.7005 15.2391C41.6224 13.3897 40.0693 11.8624 38.2021 10.8154C36.3349 9.76848 34.2217 9.24007 32.0815 9.28499C29.9413 9.32991 27.852 9.94651 26.0304 11.0709C24.2088 12.1952 22.7211 13.7864 21.7216 15.6794C20.7221 17.5724 20.2472 19.6983 20.3461 21.8367C20.445 23.9751 21.1141 26.0481 22.284 27.8408C23.454 29.6335 25.0822 31.0805 26.9998 32.032V34.6666C26.9998 35.0203 27.1403 35.3594 27.3903 35.6094C27.6404 35.8595 27.9795 36 28.3331 36H36.3331C36.6868 36 37.0259 35.8595 37.276 35.6094C37.526 35.3594 37.6665 35.0203 37.6665 34.6666V32.032C39.6633 31.0458 41.3452 29.5219 42.523 27.6318C43.7007 25.7416 44.3277 23.5603 44.3331 21.3333Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratDiversify);
export default __webpack_public_path__ + "static/media/strat_diversify.05b4029759daa238d467e3520b56d508.svg";
export { ForwardRef as ReactComponent };